import * as React from 'react';
import { HeaderMultipleFilterTable, Icon } from '@/components/common';
import Icons from '@/const/icons';
import { OptionsMultiple } from '@/components/ui/comboboxMultiple';
import { GET_CLIENT_DIRECTORY_MESSAGE_FILTER } from '@/api';
import { useQuery } from '@tanstack/react-query';
import { clientDirectoryService } from '@/api/clientDirectory';
import { Options } from '@/components/ui/combobox';
import { MessageFilterType } from '@/interfaces';
import { useFilters } from '@/hooks';
import { GC_TIME, STALE_TIME } from '@/const/common';

interface MessagesFilterProps {
	title?: string;
}

export const MessagesFilter: React.FC<MessagesFilterProps> = () => {
	const { setParamSeveralFilters, hasFilter } = useFilters();

	const optionsDefined: Options[] = [
		{
			label: '0 Messages',
			value: '0',
			icon: (
				<Icon
					src={Icons.note}
					width={18}
					height={18}
					className="text-primary"
				/>
			),
		},
		{
			label: '1 Message',
			value: '1',
			icon: (
				<Icon
					src={Icons.note}
					width={18}
					height={18}
					className="text-primary"
				/>
			),
		},
		{
			label: '+2 Messages',
			value: '2',
			icon: (
				<Icon
					src={Icons.note}
					width={18}
					height={18}
					className="text-primary"
				/>
			),
		},
	];
	const [data, setData] = React.useState<OptionsMultiple[]>([]);

	const { data: caseNameList } = useQuery({
		staleTime: STALE_TIME,
		gcTime: GC_TIME,
		refetchOnWindowFocus: false,
		queryKey: [GET_CLIENT_DIRECTORY_MESSAGE_FILTER],
		queryFn: () => clientDirectoryService.getMessageFilter(),
	});

	const getNameFilter = (value: MessageFilterType) => {
		const names: Record<MessageFilterType, string> = {
			NEW_MESSAGES: 'New',
			READ_MESSAGES: 'Read',
			UNREAD_MESSAGES: 'Unread',
		};
		return names[value];
	};

	React.useEffect(() => {
		if (caseNameList) {
			const auxOptions: Options[] = [];
			caseNameList.data.map((item) =>
				auxOptions.push({
					label: getNameFilter(item),
					value: item,
					icon: (
						<Icon
							src={Icons.sms}
							width={18}
							height={18}
							className="text-primary"
						/>
					),
				})
			);
			const auxData: OptionsMultiple[] = [
				{
					title: 'State of the Messages',
					options: auxOptions,
				},
				{
					title: 'Number of Messages',
					options: optionsDefined,
				},
			];
			setData(auxData);
		}
	}, [caseNameList]);

	const handleSelectFilters = (_key: string, value?: string) => {
		// specials filters
		switch (value) {
			case '0':
			case '1':
			case '2':
				if (value === '0' || value === '1' || value === '2') {
					setParamSeveralFilters([
						{ label: 'messageFilter', value: '' }, // reset
						{ label: 'totalMessage', value: value },
					]);
				}
				break;

			default:
				setParamSeveralFilters([
					{ label: 'totalMessage', value: '' }, // reset
					{ label: 'messageFilter', value: value },
				]);
				break;
		}
	};

	const handleClearAll = () => {
		setParamSeveralFilters([
			{ label: 'messageFilter', value: '' },
			{ label: 'totalMessage', value: '' },
		]);
	};

	return (
		<HeaderMultipleFilterTable
			title="Messages"
			searchTitle="Messages"
			filterOptions={data}
			handleSelectFilters={handleSelectFilters}
			hasFilter={hasFilter('messageFilter') || hasFilter('totalMessage')}
			handleClearAll={handleClearAll}
			classNamePopoverContent="!max-h-none"
		/>
	);
};
